import { z } from 'zod';
import { playerIdNameParser } from './utils/playerInboundUtils';
const ShowGiveChipsInboundSchema = z
    .object({
    toPlayer: z.string().transform(playerIdNameParser),
    minChips: z.number(),
    maxChips: z.number(),
    taxCurrencyPercent: z.number(),
    untaxedChipsGivenMonthly: z.number(),
    jacksCost: z.number()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'show_give_chips',
    ...rest
}));
export const SHOW_GIVE_CHIPS_PAYLOAD_DEFINITION = {
    zodSchema: ShowGiveChipsInboundSchema
};
